import type { ReactElement } from 'react';
import { useState } from 'react';
import { NativeSelect, Stack } from '@mui/material';
import type {
  MarkdownRemarkFrontmatterCopy,
  MarkdownRemarkFrontmatterGlobalPayoutData,
} from '../../../generated/types';
import { GlobalPayoutTable } from './GlobalPayoutTable';

type PpGlobalPayoutSelect = {
  availableCountries: (string | null | undefined)[];
  copy: MarkdownRemarkFrontmatterCopy;
  data: MarkdownRemarkFrontmatterGlobalPayoutData[];
};

export function GlobalPayoutSelect({
  availableCountries,
  copy,
  data,
}: PpGlobalPayoutSelect): ReactElement {
  const [selectedCountry, setSelectedCountry] = useState<string | null | undefined>(undefined);

  const selectedCountryData = data.find((item) => item.country === selectedCountry);

  return (
    <Stack maxWidth="sm" spacing={2} width="100%">
      <NativeSelect
        disableUnderline
        fullWidth
        id="off-ramp-global-payout"
        inputProps={{
          variant: 'outlined',
        }}
        value={selectedCountry ?? ''}
        variant="outlined"
        onChange={(e): void => setSelectedCountry(e.target.value)}
      >
        <option value="">Select a country</option>
        {availableCountries.filter(Boolean).map((option) => (
          <option key={option} value={option as string}>
            {option}
          </option>
        ))}
      </NativeSelect>
      {selectedCountry && <GlobalPayoutTable copy={copy} countryData={selectedCountryData} />}
    </Stack>
  );
}
